<script setup lang="ts">
const platform = useState('platform')

const menu = computed(() => platform.value?.menu.map(item => ({
  label: item.title,
  to: item.url,
})))
</script>

<template>
  <UBanner :title="platform.subheader.title" v-if="platform?.subheader?.active && platform?.subheader?.title" :actions="[{label: platform.subheader.cta.title, to: platform.subheader.cta.url, target: platform.subheader.cta.newtab ? '_blank' : '_self'}]" :to="platform.subheader.cta.url">
   <template #title>
     <span class="font-bold">{{platform.subheader.title}}</span> <span class="hidden lg:inline">{{platform.subheader.subtitle}}</span>
   </template>
  </UBanner>
  <HeaderCrf v-if="platform?.slug === 'croix-rouge'" />
  <UHeader class="flex flex-col bg-default" v-else>
    <template #title>
      <img :src="`https://www.${useBenevoltDomain()}/assets/im/platform/${platform?.slug}-logo.svg`" :alt="platform?.name" class="h-12" />
    </template>
    <template #right>
      <UButton :to="platform?.organization_url" variant="ghost" color="neutral" class="hidden md:flex">
        <Markdown :value="platform?.settings?.header?.back" unwrap="p"/>
      </UButton>
    </template>
    <template #body>
      <UNavigationMenu :items="menu" orientation="vertical" />
      <USeparator v-if="menu.length" class="my-4"/>
      <UButton :to="platform?.organization_url" variant="soft" color="neutral" block>
        <Markdown :value="platform?.settings?.header?.back" unwrap="p"/>
      </UButton>
    </template>
    <template #bottom v-if="menu.length">
      <USeparator class="hidden lg:flex" />

      <UContainer class="hidden lg:flex items-center justify-between">
        <UNavigationMenu :items="menu" variant="pill" highlight class="-mx-2.5 -mb-px" />
      </UContainer>
    </template>
  </UHeader>
</template>